export const TEST_ID = 'batteryLiveElectricalsSection';
